import { Modal } from "antd";

const FORCE_LOGOUT_ACK_KEY = "forceLogoutAcknowledged";

export const SESSION_FORCE_LOGOUT_MESSAGES = {
  LOGGED_IN_ELSEWHERE: "Logged in from another device.",
  SESSION_EXPIRED: "Session Expire, Please log in again.",
};

let isHandlingForceLogout = false;

export const isSessionForceLogoutMessage = (message) =>
  message === SESSION_FORCE_LOGOUT_MESSAGES.LOGGED_IN_ELSEWHERE ||
  message === SESSION_FORCE_LOGOUT_MESSAGES.SESSION_EXPIRED;

const getStoredAuthRaw = () => {
  const sessionRaw = sessionStorage.getItem("reduxPersist:root");
  const localRaw = localStorage.getItem("reduxPersist:root");
  return { sessionRaw, localRaw, raw: sessionRaw || localRaw };
};

export const getStoredAuthToken = () => {
  try {
    const { raw } = getStoredAuthRaw();
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.token || null;
  } catch {
    return null;
  }
};

/** Merge auth payload into storage without dropping an existing token. */
export const setStoredAuth = ({ data, token } = {}, options = {}) => {
  const { rememberMe } = options;
  const { sessionRaw, localRaw } = getStoredAuthRaw();

  let existing = {};
  try {
    const raw = sessionRaw || localRaw;
    if (raw) existing = JSON.parse(raw);
  } catch {
    existing = {};
  }

  const payload = {
    data: data !== undefined ? data : existing.data ?? null,
    token: token !== undefined ? token : existing.token ?? null,
  };

  const serialized = JSON.stringify(payload);

  if (rememberMe === true) {
    sessionStorage.removeItem("reduxPersist:root");
    localStorage.setItem("reduxPersist:root", serialized);
    return;
  }

  if (rememberMe === false) {
    localStorage.removeItem("reduxPersist:root");
    sessionStorage.setItem("reduxPersist:root", serialized);
    return;
  }

  if (localRaw) {
    localStorage.setItem("reduxPersist:root", serialized);
  } else if (sessionRaw) {
    sessionStorage.setItem("reduxPersist:root", serialized);
  } else {
    sessionStorage.setItem("reduxPersist:root", serialized);
  }
};

export const getSessionExpiredDisplayMessage = ({ reason, message } = {}) => {
  if (reason === "logged_in_elsewhere") {
    return "Logged in from another device.";
  }
  if (isSessionForceLogoutMessage(message)) {
    return message;
  }
  return "Session Expire, Please log in again.";
};

export const clearSessionStorage = () => {
  localStorage.removeItem("reduxPersist:root");
  sessionStorage.removeItem("reduxPersist:root");
  localStorage.removeItem("persist:authType");
};

/** After reload: skip duplicate modal from stale 401 / socket callbacks. */
export const consumeForceLogoutAcknowledgment = () => {
  if (!sessionStorage.getItem(FORCE_LOGOUT_ACK_KEY)) return false;
  sessionStorage.removeItem(FORCE_LOGOUT_ACK_KEY);
  clearSessionStorage();
  return true;
};

const completeForceLogoutRedirect = () => {
  sessionStorage.setItem(FORCE_LOGOUT_ACK_KEY, "1");
  clearSessionStorage();
  Modal.destroyAll();
  window.location.replace("/login");
};

export const handleForceLogout = (message, { socket, dispatch, reason } = {}) => {
  if (consumeForceLogoutAcknowledgment()) {
    return;
  }

  if (isHandlingForceLogout) return;
  isHandlingForceLogout = true;

  const displayMessage = getSessionExpiredDisplayMessage({ reason, message });

  socket?.disconnect();

  Modal.warning({
    title: "Session ended",
    content: displayMessage,
    okText: "OK",
    centered: true,
    maskClosable: false,
    keyboard: false,
    onOk: () => {
      completeForceLogoutRedirect();
    },
  });
};
